import { render, staticRenderFns } from "./SimpleGroupFieldConfig.vue?vue&type=template&id=448d4292&scoped=true"
import script from "./SimpleGroupFieldConfig.vue?vue&type=script&lang=js"
export * from "./SimpleGroupFieldConfig.vue?vue&type=script&lang=js"
import style0 from "./SimpleGroupFieldConfig.vue?vue&type=style&index=0&id=448d4292&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448d4292",
  null
  
)

export default component.exports